<template>
  <div
    v-if="!blackList.includes(Number(exhibitionId))"
    class="tag-container">
    <template v-for="(item, idx) in tag.smallList">
      <span
        v-if="idx < tagNum && smallTag"
        :key="item"
        :class="{ follow: true, white: theme === 'black' }"
        :title="`${exhibitionName}${item}`"
        @click="getTagUrl(item)">
        {{ item }}
      </span>
    </template>
    <template v-for="(item, idx) in tag.list">
      <span
        v-if="idx < tagNum && !smallTag"
        :key="item"
        :class="{ follow: true, white: theme === 'black' }"
        :title="`${exhibitionName}${item}`"
        @click="getTagUrl(item)">
        {{ item }}
      </span>
    </template>
  </div>
</template>

<script lang="ts" setup>
  import { defineProps, ref } from 'vue'
  import { blackList } from '~/utils/blackFair'

  const props = defineProps({
    exhibitionId: {
      type: [String, Number],
      default: ''
    },
    exhibitionName: {
      type: String,
      default: ''
    },
    isNoTicket: {
      type: Number,
      default: 0
    },
    smallTag: {
      type: Boolean,
      default: false
    },
    tagNum: {
      type: Number,
      default: 3
    },
    theme: {
      type: String,
      default: 'white'
    },
    thirdUrl: {
      type: String,
      default: null
    },
    industryId: {
      type: Number,
      default: 0
    }
  })

  const token = useCookie<string>('access_token')
  const { t: $t } = useI18n()

  const tag = ref({
    list: [$t('common.boothInquiry'), $t('common.ticketBooking'), $t('common.exhibitorECatalog')],
    smallList: [$t('common.booth'), $t('common.ticket'), $t('common.catalog')]
  })

  const getTagUrl = (tag: string) => {
    const exhibitionId = props.exhibitionId
    let url = ''
    if (tag === $t('common.boothInquiry') || tag === $t('common.booth')) {
      url = `/exhibition/apply/${exhibitionId}.html`
      window.open(url, '_blank')
    } else if (tag === $t('common.ticketBooking') || tag === $t('common.ticket')) {
      if (props.thirdUrl) {
        if (!token) {
          // Show login modal
        } else {
          url = props.thirdUrl
          window.open(url, '_blank')
        }
      } else {
        url = `/ticket/${exhibitionId}.html`
        window.open(url, '_blank')
      }
    } else if (tag === $t('common.exhibitorECatalog') || tag === $t('common.catalog')) {
      url = `/periodical/${exhibitionId}.html`
      window.open(url, '_blank')
    }
  }
</script>

<style lang="less" scoped>
  .tag-container {
    display: flex;
    align-items: center;

    .follow {
      font-size: 12px;
      color: #333;
      padding: 3px 6px;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #cdcfd6;
      margin-right: 8px;
      cursor: pointer;
      transition: all 0.3s;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        color: @app-color;
        border: 1px solid @app-color;
      }
    }

    .white {
      background: transparent;
      color: #fff;
    }
  }
</style>
